
import React, { useEffect } from 'react'
import { Button, Row } from 'react-bootstrap'
import { useHistory } from 'react-router'
import { toAbsoluteUrl } from 'src/app/utils/AssetHelper'
import authActions from '../../store/auth/actions'
import { useDispatch, useSelector } from 'react-redux'
import { Facebook, Goog } from '@material-ui/icons'
import { GoogleLogin } from 'react-google-login';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import { refreshTokenSetup } from 'src/app/utils/refreshToken';
import { Header } from 'src/app/components/Layout'
function AuthPage() {
    const history = useHistory();
    const dispatch = useDispatch();
    const { loginLoading, loginError, googleClientId, facebookId } = useSelector(state => state.auth)
    //console.log(googleClientId, facebookId);
    const { reset } = authActions;
    const facebookBtnClicked = () => { }

    const facebookResponse = (response) => {
        dispatch(authActions.loginGoogle({
            provider: "facebook",
            idToken: response.accessToken
        }))
    }
    const onSuccess = (res) => {
        console.log('Login Success: currentUser:', res.profileObj);
        console.log(res);
        // refreshTokenSetup(res);
        dispatch(authActions.loginGoogle({
            provider: "google",
            idToken: res.tokenId
        }))
    };

    const onFailure = (res) => {
        console.log('Login failed: res:', res);
    };
    useEffect(() => {
        dispatch(authActions.getProviders());
        return () => {
            dispatch(reset());
        }
    }, [])
    return (
        <div className="auth-page">
            <Header />
            <div className="container">
                <div className={'login-form alignment-center'}>
                <h2 className={'mt-5 mb-4 h'}>COFFEE CARD</h2>
                    <div className={'login-form__header mb-1 '}>
                         
                        <img src={toAbsoluteUrl('/FLYERR-05.png')} className="img-fluid" />
                    </div>

                    <Button className='mt-2 mb-2 re-font text-light text-uppercase' variant="info" 
                    disabled={true}
                    //onClick={() => history.push("auth/register")}
                    >
                        SIGN UP
                    </Button>
                    <p>OR</p>
                    <Button className='re-font text-light text-uppercase' variant="info" onClick={() => history.push("auth/login")}>
                        SIGN IN
                    </Button>
                    <br />
                    <p>Log in With Social Media</p>
                    {googleClientId && facebookId &&
                        <Row style={{
                            justifyContent: "center"
                        }}>

                            <GoogleLogin
                                className="google-btn"
                                clientId={googleClientId}

                                buttonText="Sign in With Google"
                                icon="google"
                                onSuccess={onSuccess}
                                onFailure={onFailure}
                                cookiePolicy={'single_host_origin'}
                                isSignedIn={false}
                            />


                            <FacebookLogin
                                render={renderProps => (
                                    <button onClick={renderProps.onClick} style={{
                                        margin: "10px",
                                        height: "40px",
                                        color: "white",
                                        borderColor: "white",
                                        backgroundColor: "#3b5998 "

                                    }}>{<Facebook />} Sign in With Facebook</button>
                                )}
                                appId={facebookId}
                                autoLoad={false}
                                fields="name,email,picture"
                                onClick={facebookBtnClicked}
                                callback={facebookResponse}
                            />
                        </Row>
                    }
                </div>
            </div>
        </div>
    )
}

export default AuthPage
